import { gql } from 'apollo-angular';

export const pcsNotificationsQuery = gql`
    query notifications {
      notifications {
        notSeenFeatures
      }
    }
`;
